import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle, PageWrapper } from '../../../components';
import { GENERATOR_ROUTES, GeneratorTabs, PlatformStep } from '../components';
import { ensureFontsLoaded } from '../config/fonts';
import { useAdsGeneratorStore } from '../model/store';

/** Krok wyboru platformy i formatu. Po zatwierdzeniu przechodzimy na adres edytora. */
export const NewCreative: FC = () => {
  const startScene = useAdsGeneratorStore((state) => state.startScene);
  const navigate = useNavigate();

  useEffect(() => {
    ensureFontsLoaded();
  }, []);

  return (
    <PageWrapper>
      <PageTitle title="Generator reklam" />
      <div className="flex flex-col gap-8">
        <GeneratorTabs />
        <PlatformStep
          onStart={(platformId, formatId) => {
            startScene(platformId, formatId);
            navigate(GENERATOR_ROUTES.editor);
          }}
        />
      </div>
    </PageWrapper>
  );
};
